var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.5 17.2",
    style: {
      enableBackground: "new 0 0 21.5 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E4EAFF;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    transform: "translate(-48.749 -958.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    className: "st0",
    d: "M54.9,971.4c1.4,2.4,4,3.8,6.7,3.8c4.3,0,7.9-3.5,7.9-7.8c0-4.3-3.5-7.9-7.8-7.9c0,0,0,0,0,0 c-2.7,0-5.2,1.4-6.7,3.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    transform: "translate(69.499 970.214) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    className: "st1",
    x1: 7.9,
    y1: 2.9,
    x2: 18.6,
    y2: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    className: "st2",
    d: "M17.2,5.7L20,2.9L17.2,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/Signout.21067d5709d022eba9cfb0eecb31be48.svg";
export { ForwardRef as ReactComponent };